import styled, { css } from 'styled-components';

export const Div = styled.div`
  padding: 0.8rem 1.2rem;
  display: inline;
  white-space: nowrap;
  width: 200px;
  margin: 0.5rem 0.6rem;
  border: 1px black dotted;
  border-radius: 0.25em;
  
  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && css`
    padding: ${theme.div?.padding || '0.8rem 1.2rem'};
    display: ${theme.div?.display || 'inline'};
    white-space: ${theme.div?.whiteSpace || 'nowrap'};
    width: ${theme.div?.width || '200px'};
    margin: ${theme.div?.margin || '0.5rem 0.6rem'};
    border: ${theme.div?.border || '1px black dotted'};
    border-radius: ${theme.div?.borderRadius || '0.25em'};
  `}

  ${props => props.loading && css`
    background-color: ${({ theme }) => theme.name !== 'blank' ? 
      theme.div?.states?.loading?.backgroundColor || '#ccc' : '#ccc'};
  `}
  
  ${props => props.playing && css`
    background-color: ${({ theme }) => theme.name !== 'blank' ? 
      theme.div?.states?.playing?.backgroundColor || '#9c9' : '#9c9'};
    outline: none;
  `}
  
  ${props => props.me && css`
    background-color: ${({ theme }) => theme.name !== 'blank' ? 
      theme.div?.states?.me?.backgroundColor || '#f0dddd' : '#f0dddd'};
    outline: none;
    padding: 0;
    margin: 20px;
    width: 160px;
  `}
  
  &:not(.nodata):hover {
    ${({ theme }) => theme.name !== 'blank' && css`
      border: ${theme.div?.hover?.border || '1px #111 solid'};
      cursor: ${theme.div?.hover?.cursor || 'pointer'};
    `}
  }

  ${(props) => props.width && `width: ${props.width};`}
  ${(props) => props.nodata && `
    text-align: ${({ theme }) => theme.name !== 'blank' ? 
      theme.div?.states?.nodata?.textAlign || 'center' : 'center'};
    font-style: ${({ theme }) => theme.name !== 'blank' ? 
      theme.div?.states?.nodata?.fontStyle || 'italic' : 'italic'};
  `}
  
  &:focus {
    outline: none;
    ${({ theme }) => theme.name !== 'blank' && css`
      border-color: ${theme.div?.focus?.borderColor || 'grey'};
      box-shadow: ${theme.div?.focus?.boxShadow || '0 0 3px grey'};
    `}
  }
`;

export const TextButtonDiv = styled.div`
  padding: 10px;
  display: inline;
  white-space: nowrap;
  width: 180px;
  margin: 10px;
  border: 1px black dotted;
  border-radius: 0.25em;
  
  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && css`
    padding: ${theme.textButtonDiv?.padding || '10px'};
    display: ${theme.textButtonDiv?.display || 'inline'};
    white-space: ${theme.textButtonDiv?.whiteSpace || 'nowrap'};
    width: ${theme.textButtonDiv?.width || '180px'};
    margin: ${theme.textButtonDiv?.margin || '10px'};
    border: ${theme.textButtonDiv?.border || '1px black dotted'};
    border-radius: ${theme.textButtonDiv?.borderRadius || '0.25em'};
  `}

  ${props => props.loading && css`
    background-color: ${({ theme }) => theme.name !== 'blank' ? 
      theme.textButtonDiv?.states?.loading?.backgroundColor || '#ccc' : '#ccc'};
  `}
  
  ${props => props.playing && css`
    background-color: ${({ theme }) => theme.name !== 'blank' ? 
      theme.textButtonDiv?.states?.playing?.backgroundColor || '#9c9' : '#9c9'};
    outline: none;
  `}
  
  ${props => props.me && css`
    background-color: ${({ theme }) => theme.name !== 'blank' ? 
      theme.textButtonDiv?.states?.me?.backgroundColor || '#f0dddd' : '#f0dddd'};
    outline: none;
    padding: 0;
    margin: 20px;
    width: 160px;
  `}
  
  &:not(.nodata):hover {
    ${({ theme }) => theme.name !== 'blank' && css`
      border: ${theme.textButtonDiv?.hover?.border || '1px #111 solid'};
      cursor: ${theme.textButtonDiv?.hover?.cursor || 'pointer'};
    `}
  }

  ${(props) => props.width && `width: ${props.width};`}
  ${(props) => props.nodata && `
    text-align: ${({ theme }) => theme.name !== 'blank' ? 
      theme.textButtonDiv?.states?.nodata?.textAlign || 'center' : 'center'};
    font-style: ${({ theme }) => theme.name !== 'blank' ? 
      theme.textButtonDiv?.states?.nodata?.fontStyle || 'italic' : 'italic'};
  `}
  
  &:focus {
    outline: none;
    ${({ theme }) => theme.name !== 'blank' && css`
      border-color: ${theme.textButtonDiv?.focus?.borderColor || 'grey'};
      box-shadow: ${theme.textButtonDiv?.focus?.boxShadow || '0 0 3px grey'};
      margin: ${theme.textButtonDiv?.focus?.margin || '1rem'};
      padding: ${theme.textButtonDiv?.focus?.padding || '1rem'};
    `}
  }
`;

